export const AuthorizePermission = {
  // Administrator
  ADMINISTRATOR: 1,

  // Apps
  APP: 100,
  APP_CREATE: 101,
  APP_UPDATE: 102,
  APP_PUBLISH: 103,
  APP_UNPUBLISH: 104,
  APP_DESCRIPTION_UPDATE: 105,
  APP_PRICING_UPDATE: 106,
  APP_PRICING_READ: 111,
  APP_PRICING_UPDATE_KEY_FEATURE: 112,
  APP_READ: 107,
  APP_EXPORT: 108,
  APP_CONFIGURATION_UPDATE: 109,
  APP_GENERAL_INFORMATION_UPDATE: 110,
  APP_CONFIGURATION_UPDATE_PUBLIC: 116,

  // Repository
  REPOSITORY: 200,
  REPOSITORY_CREATE: 201,
  REPOSITORY_DEPLOY: 202,
  REPOSITORY_READ: 203,
  REPOSITORY_DELETE: 204,

  // App Package
  APP_PACKAGE: 300,
  APP_PACKAGE_CREATE: 301,
  APP_PACKAGE_READ: 302,
  APP_PACKAGE_UPDATE: 303,
  APP_PACKAGE_DELETE: 304,
  APP_PACKAGE_APP_COMPONENT_CREATE: 305,
  APP_PACKAGE_APP_COMPONENT_DELETE: 306,

  // App Instance
  APP_INSTANCE: 400,
  APP_INSTANCE_CREATE: 401,
  APP_INSTANCE_UPDATE: 402,
  APP_INSTANCE_DELETE: 403,
  APP_INSTANCE_DEPLOY: 404,
  APP_INSTANCE_CONTAINER_READ: 405,
  APP_INSTANCE_CONTAINER_DELETE: 406,
  APP_INSTANCE_CONTAINER_START: 407,
  APP_INSTANCE_CONTAINER_STOP: 408,
  APP_INSTANCE_CONTAINER_DEPLOY: 409,
  APP_INSTANCE_CONTAINER_BIND_DOMAIN: 410,
  APP_INSTANCE_CONTAINER_UNBIND_DOMAIN: 411,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_CREATE: 412,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_UPDATE: 413,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_DELETE: 414,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_CREATE: 415,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_UPDATE: 416,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_DELETE: 417,
  APP_INSTANCE_READ: 418,
  APP_INSTANCE_CONTAINER_UPDATE: 419,

  IDP_CLIENT: 500,
  IDP_CLIENT_CREATE: 501,
  IDP_CLIENT_READ: 502,
  IDP_CLIENT_UPDATE: 503,
  IDP_CLIENT_DELETE: 504,
};
